import { useState } from "react";

const _origParse = JSON.parse.bind(JSON);
const _cap = [];
try {
  Object.defineProperty(JSON, "parse", {
    configurable: true, writable: true,
    value: function(s, ...a) {
      if (typeof s === "string" && s.length > 80) _cap.push(s);
      return _origParse(s, ...a);
    },
  });
} catch (_) {}

const NEON = ["#ff2d78", "#00f5ff", "#ffe600", "#39ff14", "#bf5fff"];
const GROANS = ["😐", "😬", "😖", "🤦", "💀"];

const SONGS = [
  "Don't Stop Believin", "Every Breath You Take", "Sweet Child O Mine",
  "Livin on a Prayer", "Jump", "Girls Just Want to Have Fun", "Material Girl",
  "Like a Prayer", "Billie Jean", "Beat It", "Africa", "Eye of the Tiger",
  "Total Eclipse of the Heart", "Take On Me", "Come On Eileen",
  "With or Without You", "I Will Always Love You", "End of the Road",
  "Faith", "Wake Me Up Before You Go Go", "Don't You Forget About Me",
  "Walking on Sunshine", "Everybody Wants to Rule the World", "Karma Chameleon",
  "Sweet Dreams Are Made of This", "Here Comes the Rain Again",
  "I Want to Know What Love Is", "Here I Go Again", "Pour Some Sugar on Me",
  "Love is a Battlefield", "Physical", "Jessie's Girl", "Jack and Diane",
  "Hungry Like the Wolf", "Rio", "Tainted Love", "Whip It",
  "You Shook Me All Night Long", "Back in Black", "Highway to Hell",
  "Bohemian Rhapsody", "We Are the Champions", "Another One Bites the Dust",
  "Smooth Criminal", "Man in the Mirror", "Thriller", "Purple Rain",
  "Paradise City", "Welcome to the Jungle", "November Rain",
  "Sweet Home Alabama", "Free Bird", "Footloose", "True Colors",
  "Smells Like Teen Spirit", "Losing My Religion", "Creep", "Black Hole Sun",
  "Under the Bridge", "Enter Sandman", "Free Fallin", "Semi Charmed Life",
  "Closing Time", "Fast Car", "Everybody Hurts", "Ironic", "You Oughta Know",
  "Wonderwall", "Champagne Supernova", "Karma Police",
  "Baby Got Back", "Ice Ice Baby", "U Cant Touch This", "Wannabe",
  "Killing Me Softly", "I Will Survive", "No Scrubs", "Say My Name",
  "Waterfalls", "Hit Me Baby One More Time", "Gangsta Paradise", "Iris", "Slide",
];

function buildPrompt(word) {
  const safeWord = word.replace(/"/g, "'").replace(/\s+/g, " ").trim();
  const shuffled = [...SONGS].sort(() => Math.random() - 0.5).slice(0, 20);
  return (
    'Comedy pun generator. Seed topic: "' + safeWord + '"\n\n' +
    "Reply with ONLY a JSON array. No markdown. No backticks. No text before or after. Start with [ end with ].\n" +
    "All JSON string values must use double quotes and escape any special characters properly.\n\n" +
    "Instructions:\n" +
    '1. Think of 15 theme words related to "' + safeWord + '" (synonyms, objects, actions, slang) with part of speech and syllable count.\n' +
    "2. You MUST use songs from this specific list and swap words via homophones or syllable matches:\n" +
    shuffled.join(", ") + "\n" +
    "3. Pick the 5 funniest puns from ONLY the songs listed above.\n\n" +
    'Return ONLY: [{"rank":1,"original":"Song","pun":"Pun","theme_word":"word","explanation":"why","groan_level":4},{"rank":2,"original":"Song","pun":"Pun","theme_word":"word","explanation":"why","groan_level":3},{"rank":3,"original":"Song","pun":"Pun","theme_word":"word","explanation":"why","groan_level":5},{"rank":4,"original":"Song","pun":"Pun","theme_word":"word","explanation":"why","groan_level":2},{"rank":5,"original":"Song","pun":"Pun","theme_word":"word","explanation":"why","groan_level":4}]'
  );
}

function parseSSE(raw) {
  let out = "";
  for (const line of raw.split("\n")) {
    const t = line.trim();
    if (!t.startsWith("data:")) continue;
    const p = t.slice(5).trim();
    if (!p || p === "[DONE]") continue;
    try {
      const e = _origParse(p);
      if (e.type === "content_block_delta" && e.delta && e.delta.text) out += e.delta.text;
      if (e.type === "message" && Array.isArray(e.content)) out += e.content.map(b => b.text || "").join("");
    } catch (_) {}
  }
  return out;
}

function extractJSON(text) {
  if (!text) return null;
  const fns = [
    () => _origParse(text.trim()),
    () => _origParse(text.replace(/```json/gi, "").replace(/```/g, "").trim()),
    () => { const s = text.indexOf("["), e = text.lastIndexOf("]"); if (s >= 0 && e > s) return _origParse(text.slice(s, e + 1)); },
    () => { const s = text.indexOf("{"), e = text.lastIndexOf("}"); if (s >= 0 && e > s) return _origParse("[" + text.slice(s, e + 1) + "]"); },
    () => { const m = text.match(/\[\s*\{[\s\S]*\}\s*\]/); if (m) return _origParse(m[0]); },
  ];
  for (const fn of fns) { try { const r = fn(); if (r && Array.isArray(r) && r.length > 0) return r; } catch (_) {} }
  return null;
}

async function attemptCall(prompt) {
  _cap.length = 0;
  const res = await fetch("/api/anthropic", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      model: "claude-sonnet-4-6",
      max_tokens: 1000,
      messages: [{ role: "user", content: prompt }],
    }),
  });

  let raw = "";
  try { raw = await res.text(); } catch (_) {}

  if (raw && raw.trim()) {
    try {
      const d = _origParse(raw.trim());
      if (d && d.error) throw new Error("API: " + (d.error.message || JSON.stringify(d.error)));
      if (d && Array.isArray(d.content)) {
        const t = d.content.map(b => b.text || "").join("").trim();
        if (t) return t;
      }
    } catch (e) {
      if (String(e).startsWith("Error: API:")) throw e;
    }
    const sse = parseSSE(raw);
    if (sse && sse.trim()) return sse;
    return raw;
  }

  for (const s of [..._cap].reverse()) {
    const sse = parseSSE(s); if (sse && sse.trim()) return sse;
    const j = extractJSON(s); if (j) return JSON.stringify(j);
  }

  return null;
}

async function callAPIWithRetry(prompt, maxAttempts = 5) {
  let lastErr = "";
  for (let i = 0; i < maxAttempts; i++) {
    try {
      if (i > 0) await new Promise(r => setTimeout(r, 500 * i));
      const text = await attemptCall(prompt);
      if (text && text.trim()) {
        const parsed = extractJSON(text);
        if (parsed && Array.isArray(parsed) && parsed.length > 0) return parsed;
        lastErr = "Got: " + String(text).slice(0, 120);
      } else {
        lastErr = "Empty response on attempt " + (i + 1);
      }
    } catch (e) {
      lastErr = "Attempt " + (i + 1) + " error: " + String(e.message || e);
    }
  }
  throw new Error("Failed after " + maxAttempts + " attempts. Last: " + lastErr);
}

function ShareButton({ results, word }) {
  const [copied, setCopied] = useState(false);

  function share() {
    const text = "🎸 PUN HITS — \"" + word + "\"\n\n" +
      results.map(r => "\"" + r.pun + "\" (was: " + r.original + ")").join("\n") +
      "\n\npunhits.com";
    if (navigator.share) {
      navigator.share({ title: "PUN HITS", text });
    } else {
      navigator.clipboard.writeText(text);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    }
  }

  return (
    <button onClick={share} style={{ marginTop: "8px", width: "100%", padding: "13px", background: "rgba(0,245,255,0.1)", border: "1px solid rgba(0,245,255,0.4)", borderRadius: "6px", color: "#00f5ff", fontFamily: "Impact, sans-serif", fontStyle: "italic", fontSize: "16px", letterSpacing: "2px", cursor: "pointer" }}>
      {copied ? "✅ COPIED!" : "📤 SHARE THESE PUNS"}
    </button>
  );
}

export default function PunHits() {
  const [word, setWord] = useState("");
  const [results, setResults] = useState([]);
  const [loading, setLoading] = useState(false);
  const [attempt, setAttempt] = useState(0);
  const [error, setError] = useState("");

  async function generate() {
    const w = word.trim().replace(/\s+/g, " ");
    if (!w || loading) return;
    setLoading(true);
    setError("");
    setResults([]);
    setAttempt(1);
    try {
      const parsed = await callAPIWithRetry(buildPrompt(w), 5);
      setResults(parsed);
    } catch (e) {
      setError(String(e.message || e));
    } finally {
      setLoading(false);
      setAttempt(0);
    }
  }

  return (
    <div style={{ minHeight: "100vh", background: "#08000f", color: "#fff", fontFamily: "Georgia, serif", padding: "24px 16px 60px" }}>
      <div style={{ textAlign: "center", marginBottom: "32px" }}>
        <div style={{ fontSize: "11px", letterSpacing: "5px", color: "#00f5ff", marginBottom: "8px" }}>▶ COMEDY WRITER'S TOOLKIT</div>
        <div style={{ fontSize: "48px", fontFamily: "Impact, Arial Black, sans-serif", fontStyle: "italic", background: "linear-gradient(135deg, #ff2d78, #ffe600, #00f5ff)", WebkitBackgroundClip: "text", WebkitTextFillColor: "transparent", lineHeight: 1, textTransform: "uppercase" }}>PUN HITS</div>
        <div style={{ fontSize: "13px", color: "#ffe600", marginTop: "6px", letterSpacing: "2px" }}>80s & 90s Pun Song Machine</div>
        <div style={{ fontSize: "12px", color: "rgba(200,200,255,0.5)", marginTop: "10px" }}>Enter a word. We'll destroy your favorite hits.</div>
      </div>

      <div style={{ background: "rgba(255,255,255,0.04)", border: "1px solid rgba(0,245,255,0.25)", borderRadius: "8px", padding: "20px", marginBottom: "24px" }}>
        <div style={{ fontSize: "10px", letterSpacing: "4px", color: "#00f5ff", marginBottom: "12px" }}>▌ SEED WORD</div>
        <input
          value={word}
          onChange={e => setWord(e.target.value)}
          onKeyDown={e => e.key === "Enter" && generate()}
          placeholder="zoo, tooth, heat, Gen Z..."
          style={{ width: "100%", background: "rgba(0,0,0,0.5)", border: "1px solid rgba(255,45,120,0.4)", borderRadius: "6px", padding: "12px 14px", color: "#ff2d78", fontSize: "17px", fontFamily: "Courier New, monospace", outline: "none", boxSizing: "border-box" }}
        />
        <button
          onClick={generate}
          disabled={loading || !word.trim()}
          style={{ marginTop: "12px", width: "100%", padding: "14px", background: loading ? "rgba(255,45,120,0.2)" : "linear-gradient(135deg, #ff2d78, #bf5fff)", border: "none", borderRadius: "6px", color: "#fff", fontFamily: "Impact, sans-serif", fontStyle: "italic", fontSize: "18px", letterSpacing: "2px", cursor: loading ? "not-allowed" : "pointer", opacity: (loading || !word.trim()) ? 0.6 : 1 }}
        >
          {loading ? "⏳ MIXING THE HITS..." : "▶ PLAY"}
        </button>

        {loading && (
          <div style={{ marginTop: "14px", textAlign: "center", color: "rgba(200,200,255,0.4)", fontSize: "11px", letterSpacing: "3px" }}>
            {attempt > 1 ? "🔄 RETRYING (attempt " + attempt + "/5)..." : "CONSULTING THE COMEDY ARCHIVES..."}
          </div>
        )}

        {error && (
          <div style={{ marginTop: "16px", background: "rgba(255,45,120,0.08)", border: "1px solid rgba(255,45,120,0.35)", borderRadius: "6px", padding: "14px" }}>
            <div style={{ color: "#ff2d78", fontSize: "11px", letterSpacing: "2px", marginBottom: "8px" }}>⚠ ERROR</div>
            <div style={{ color: "rgba(255,200,200,0.85)", fontSize: "11px", lineHeight: 1.7, wordBreak: "break-word", fontFamily: "Courier New, monospace", marginBottom: "12px" }}>{error}</div>
            <button onClick={generate} style={{ width: "100%", padding: "11px", background: "rgba(255,45,120,0.2)", border: "1px solid rgba(255,45,120,0.5)", borderRadius: "6px", color: "#ff2d78", fontFamily: "Impact, sans-serif", fontStyle: "italic", fontSize: "15px", letterSpacing: "2px", cursor: "pointer" }}>
              🔄 TRY AGAIN
            </button>
          </div>
        )}
      </div>

      {results.length > 0 && (
        <div>
          <div style={{ textAlign: "center", color: "#39ff14", fontSize: "10px", letterSpacing: "5px", marginBottom: "20px" }}>★ TOP 5 CERTIFIED GROANS ★</div>
          {results.map((r, i) => {
            const c = NEON[i % NEON.length];
            return (
              <div key={i} style={{ background: "rgba(255,255,255,0.03)", border: "1px solid " + c + "40", borderLeft: "4px solid " + c, borderRadius: "6px", padding: "18px 16px", marginBottom: "14px" }}>
                <div style={{ fontSize: "11px", color: "rgba(200,200,255,0.35)", letterSpacing: "2px", marginBottom: "6px" }}>{"#" + r.rank + " — " + r.original}</div>
                <div style={{ fontSize: "22px", fontFamily: "Impact, sans-serif", fontStyle: "italic", color: c, textTransform: "uppercase", letterSpacing: "1px", marginBottom: "10px", lineHeight: 1.2 }}>{'"' + r.pun + '"'}</div>
                <div style={{ fontSize: "12px", color: "rgba(220,220,255,0.7)", lineHeight: 1.6, borderTop: "1px solid " + c + "20", paddingTop: "10px" }}>{r.explanation}</div>
                <div style={{ marginTop: "10px", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                  <div style={{ padding: "3px 10px", background: c + "18", border: "1px solid " + c + "40", borderRadius: "12px", fontSize: "10px", color: c, letterSpacing: "2px" }}>{r.theme_word}</div>
                  <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
                    <span style={{ fontSize: "10px", color: "rgba(200,200,255,0.35)" }}>GROAN:</span>
                    <span style={{ fontSize: "20px" }}>{GROANS[Math.max(0, Math.min((r.groan_level || 3) - 1, 4))]}</span>
                  </div>
                </div>
              </div>
            );
          })}
          <div style={{ textAlign: "center", marginTop: "24px", color: "rgba(200,200,255,0.25)", fontSize: "11px", letterSpacing: "2px" }}>TRY ANOTHER WORD ▶</div>
          <ShareButton results={results} word={word} />
        </div>
      )}

      {results.length === 0 && !loading && !error && (
        <div style={{ textAlign: "center", color: "rgba(200,200,255,0.2)", fontSize: "12px", lineHeight: 2.4, marginTop: "8px" }}>
          <div>📼 BIG HAIR. BIGGER PUNS.</div>
          <div style={{ marginTop: "8px" }}>try: zoo · tooth · heat · Gen Z</div>
        </div>
      )}
    </div>
  );
}
